import React from 'react';
import Alert from 'react-bootstrap/Alert';

const ConsoleLog = ({ logs }) => (
  <>
    {Boolean(logs.length) && (
      <Alert variant="dark">
        {logs.map((log, i) => {
          if (typeof log === 'object' && log.length) {
            return (
              <>
                {log.map((s, i) => (
                  <pre key={i}>{s}</pre>
                ))}
              </>
            );
          }
          return <pre key={i}>{log}</pre>;
        })}
      </Alert>
    )}
  </>
);

export default ConsoleLog;
